import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const publicApi = axios.create({ baseURL: API });

// The admin client sends/receives the httpOnly session cookie set by the backend on
// login (withCredentials). The JWT itself is never stored in localStorage/JS-accessible
// storage, which protects it from theft via XSS.
export const adminApi = axios.create({ baseURL: API, withCredentials: true });

/**
 * Resolve an image reference returned by the backend into a fully
 * qualified URL usable in <img src>. Handles:
 * - Full external URLs (demo data from Unsplash/Pexels)
 * - Backend-served object storage paths (/api/files/...)
 */
export const getImageUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  if (path.startsWith("/api/")) return `${BACKEND_URL}${path}`;
  // Henüz backend'den dönmemiş, ham depolama yolu (örn. yeni yüklenen ama kaydedilmemiş
  // bir görsel). Backend'in to_image_urls() ile yaptığı aynı çözümlemeyi burada da
  // yapıyoruz ki formda anlık önizleme de, kayıtlı ilan da aynı şekilde çalışsın.
  return `${BACKEND_URL}/api/files/${path}`;
};

export const getErrorMessage = (error, fallback = "Bir hata oluştu. Lütfen tekrar deneyin.") => {
  return error?.response?.data?.detail || error?.message || fallback;
};

